import { Eye, EyeOff } from 'lucide-react'
import { forwardRef, useState, type InputHTMLAttributes } from 'react'
import { Input } from '@/components/ui/Input'
import { useT } from '@/i18n'

export const PasswordInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function PasswordInput(props, ref) {
  const t = useT()
  const [visible, setVisible] = useState(false)
  return (
    <Input
      ref={ref}
      {...props}
      type={visible ? 'text' : 'password'}
      className="h-11"
      trailing={
        <button
          type="button"
          onClick={() => setVisible((value) => !value)}
          aria-label={visible ? t('auth.hidePassword') : t('auth.showPassword')}
          className="flex size-7 items-center justify-center rounded-[calc(7px*var(--radius-scale))] text-subtle hover:bg-hover hover:text-fg"
        >
          {visible ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
        </button>
      }
    />
  )
})
